import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top
    }, [pathname]); // Trigger on pathname change

    return null; // No need to render anything
};

export default ScrollToTop;